const clearCache = (cache, patternToDelete) =>
  Object.keys(cache.data.data).forEach(key => {
    if (key.match(patternToDelete)) {
      cache.data.delete(key);
    }
  });

export default clearCache;
